import React from 'react'
import PropTypes from 'prop-types'
import { TanstackTableWrapper } from '../../../../../../../common/functionalComponents'

export const TableBody = ({ table }) => <TanstackTableWrapper table={table} />

TableBody.propTypes = {
  table: PropTypes.object,
}
